<div mat-dialog-title>
    <h1>Error</h1>
</div>
<div mat-dialog-content>
    <div mat-dialog-title>
        <label class="mat-headline-6">{{data.errorMessage}}</label>
    </div>
</div>
